const trashIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.75 1.5C3.35218 1.5 2.97064 1.65804 2.68934 1.93934C2.40804 2.22064 2.25 2.60218 2.25 3V4.5C2.25 4.89782 2.40804 5.27936 2.68934 5.56066C2.97064 5.84196 3.35218 6 3.75 6H4.5V19.5C4.5 20.2956 4.81607 21.0587 5.37868 21.6213C5.94129 22.1839 6.70435 22.5 7.5 22.5H16.5C17.2956 22.5 18.0587 22.1839 18.6213 21.6213C19.1839 21.0587 19.5 20.2956 19.5 19.5V6H20.25C20.6478 6 21.0294 5.84196 21.3107 5.56066C21.592 5.27936 21.75 4.89782 21.75 4.5V3C21.75 2.60218 21.592 2.22064 21.3107 1.93934C21.0294 1.65804 20.6478 1.5 20.25 1.5H15C15 1.10218 14.842 0.720644 14.5607 0.43934C14.2794 0.158035 13.8978 0 13.5 0L10.5 0C10.1022 0 9.72064 0.158035 9.43934 0.43934C9.15804 0.720644 9 1.10218 9 1.5H3.75ZM8.25 7.5C8.44891 7.5 8.63968 7.57902 8.78033 7.71967C8.92098 7.86032 9 8.05109 9 8.25V18.75C9 18.9489 8.92098 19.1397 8.78033 19.2803C8.63968 19.421 8.44891 19.5 8.25 19.5C8.05109 19.5 7.86032 19.421 7.71967 19.2803C7.57902 19.1397 7.5 18.9489 7.5 18.75V8.25C7.5 8.05109 7.57902 7.86032 7.71967 7.71967C7.86032 7.57902 8.05109 7.5 8.25 7.5ZM12 7.5C12.1989 7.5 12.3897 7.57902 12.5303 7.71967C12.671 7.86032 12.75 8.05109 12.75 8.25V18.75C12.75 18.9489 12.671 19.1397 12.5303 19.2803C12.3897 19.421 12.1989 19.5 12 19.5C11.8011 19.5 11.6103 19.421 11.4697 19.2803C11.329 19.1397 11.25 18.9489 11.25 18.75V8.25C11.25 8.05109 11.329 7.86032 11.4697 7.71967C11.6103 7.57902 11.8011 7.5 12 7.5ZM16.5 8.25C16.5 8.05109 16.421 7.86032 16.2803 7.71967C16.1397 7.57902 15.9489 7.5 15.75 7.5C15.5511 7.5 15.3603 7.57902 15.2197 7.71967C15.079 7.86032 15 8.05109 15 8.25V18.75C15 18.9489 15.079 19.1397 15.2197 19.2803C15.3603 19.421 15.5511 19.5 15.75 19.5C15.9489 19.5 16.1397 19.421 16.2803 19.2803C16.421 19.1397 16.5 18.9489 16.5 18.75V8.25Z"
        fill="url(#paint0_linear)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="12"
        y1="0"
        x2="12"
        y2="22.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#25A6E3" />
        <stop offset="1" stopColor="#0194D9" />
      </linearGradient>
      <clipPath id="clip0">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const eyeIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.75 12C15.75 12.9946 15.3549 13.9484 14.6517 14.6517C13.9484 15.3549 12.9946 15.75 12 15.75C11.0054 15.75 10.0516 15.3549 9.34835 14.6517C8.64509 13.9484 8.25 12.9946 8.25 12C8.25 11.0054 8.64509 10.0516 9.34835 9.34835C10.0516 8.64509 11.0054 8.25 12 8.25C12.9946 8.25 13.9484 8.64509 14.6517 9.34835C15.3549 10.0516 15.75 11.0054 15.75 12Z"
      fill="url(#paint0_linear)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 12C0 12 4.5 3.75 12 3.75C19.5 3.75 24 12 24 12C24 12 19.5 20.25 12 20.25C4.5 20.25 0 12 0 12ZM12 17.25C13.3924 17.25 14.7277 16.6969 15.7123 15.7123C16.6969 14.7277 17.25 13.3924 17.25 12C17.25 10.6076 16.6969 9.27226 15.7123 8.28769C14.7277 7.30312 13.3924 6.75 12 6.75C10.6076 6.75 9.27226 7.30312 8.28769 8.28769C7.30312 9.27226 6.75 10.6076 6.75 12C6.75 13.3924 7.30312 14.7277 8.28769 15.7123C9.27226 16.6969 10.6076 17.25 12 17.25Z"
      fill="url(#paint1_linear)"
    />
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="12"
        y1="8.25"
        x2="12"
        y2="15.75"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#25A6E3" />
        <stop offset="1" stopColor="#0194D9" />
      </linearGradient>
      <linearGradient
        id="paint1_linear"
        x1="12"
        y1="3.75"
        x2="12"
        y2="20.25"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#25A6E3" />
        <stop offset="1" stopColor="#0194D9" />
      </linearGradient>
    </defs>
  </svg>
);

const penIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.81326 15.4667L1.54659 20.9333C1.50289 21.1332 1.50439 21.3402 1.55097 21.5394C1.59756 21.7386 1.68805 21.9249 1.81583 22.0846C1.94362 22.2443 2.10547 22.3735 2.28957 22.4627C2.47368 22.5518 2.67537 22.5988 2.87992 22.6C2.97524 22.6096 3.07128 22.6096 3.16659 22.6L8.66659 21.3333L19.2266 10.8133L13.3333 4.93333L2.81326 15.4667Z"
      fill="url(#paint0_linear)"
    />
    <path
      d="M22.5466 5.54667L18.6133 1.61333C18.3547 1.35604 18.0048 1.21161 17.64 1.21161C17.2752 1.21161 16.9252 1.35604 16.6666 1.61333L14.48 3.8L20.3666 9.68667L22.5533 7.5C22.6813 7.37139 22.7826 7.2188 22.8516 7.05098C22.9205 6.88315 22.9557 6.70338 22.955 6.52195C22.9544 6.34052 22.918 6.161 22.848 5.99364C22.7779 5.82629 22.6755 5.6744 22.5466 5.54667Z"
      fill="url(#paint1_linear)"
    />
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="10.3707"
        y1="4.93333"
        x2="10.3707"
        y2="22.6072"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#25A6E3" />
        <stop offset="1" stopColor="#0194D9" />
      </linearGradient>
      <linearGradient
        id="paint1_linear"
        x1="18.7175"
        y1="1.21161"
        x2="18.7175"
        y2="9.68667"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#25A6E3" />
        <stop offset="1" stopColor="#0194D9" />
      </linearGradient>
    </defs>
  </svg>
);

export { trashIcon, eyeIcon, penIcon };
